module.exports = __webpack_public_path__ + "img/ch4pic7.6929a67d.png";